import {
  createRouter,
  createWebHashHistory,
  type RouteRecordRaw
} from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Reach',
    component: () => import('~/views/Reach.vue')
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
